import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z";

export default function RecordingDot(props: IconProps) {
  return <SVGIcon path={path} {...props} />;
}
